import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { API } from '../../utils';
import { count } from '../../utils/sendStats';
import { configTransformer } from '../../transformer';
import Scroller from '../Scroller';
import { getTestVariation, TEST_VARIATION_A, TEST_VARIATION_B, EXPERIMENTS } from '../../utils/experiments';
import { ROLLOUTS } from '../../utils/rollouts';
import MenuPanel from './MenuPanel';

const METRIC_PREFIX = 'navigation_menu';

class NavigationMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            config: props.config
        };
    }

    componentDidMount() {
        count(`${METRIC_PREFIX}.should_pre_render.${this.props.shouldPreRender}`);
        const hasFullConfig = !!this.state.config.level_2;

        !this.props.shouldPreRender && !hasFullConfig &&
            axios.get(API.FETCH_NAVIGATION_CONFIG)
                .then((res) => {
                    const { config } = res.data;
                    this.setState({
                        config: { ...this.state.config, ...configTransformer(config, this.props.locale, this.props.mode) }
                    });

                    count(`${METRIC_PREFIX}.ajax.lazy.succeeded`);

                }).catch((error) => {
                    error.description = 'Failed to fetch category navigation items';
                    logger.error(error);
                    count(`${METRIC_PREFIX}.ajax.lazy.failed`);
                });
    }

    componentDidUpdate(prevProps) {
        if (this.props.config !== prevProps.config) {

            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ config: this.props.config });
        }
    }

    render() {
        const { theme, shouldPreRender, mode, currency, rollouts } = this.props;
        const { config } = this.state;
        const { level_1 = {} } = config;

        const { abTests, organizationId, userId, url } = getContext();

        let variation = TEST_VARIATION_A;

        const inMustangsProNavBarJobPostEp = rollouts[ROLLOUTS.MUSTANGS_PRO_NAV_BAR_JOB_POST_EP];
        const inMustangsMpNavBarJobPostEp = rollouts[ROLLOUTS.MUSTANGS_MP_NAV_BAR_JOB_POST_EP];

        if (userId) {
            const isProUrl = url.includes('pro.');

            const shouldRunTest = !!organizationId || (!organizationId && !isProUrl);

            if (shouldRunTest && inMustangsProNavBarJobPostEp) {
                variation = TEST_VARIATION_B;
            }

            if (shouldRunTest && inMustangsMpNavBarJobPostEp) {
                variation = getTestVariation(abTests, EXPERIMENTS.MUSTANGS_MP_NAV_BAR_JOB_POST_EP);
            }
        }

        const isBriefButtonOnLeftVariation = variation === TEST_VARIATION_B;
        const isControlTest = variation === TEST_VARIATION_A;
        let ctaSource = 'none';
        if (isBriefButtonOnLeftVariation) {
            ctaSource = 'nav_bar_left';
        }

        return (
            <Scroller classname={theme}
                mode={mode}
                currency={currency}
                isBriefButtonOnLeftVariation={isBriefButtonOnLeftVariation}
                isControlTest={isControlTest}
                ctaSource={ctaSource}>
                {
                    level_1[0]?.map((panel) => (
                        <MenuPanel key={panel.id}
                            mode={mode}
                            item={panel}
                            config={config}
                            shouldPreRender={shouldPreRender}
                            isBriefButtonOnLeftVariation={isBriefButtonOnLeftVariation}
                            eventTracker={{ vertical: panel.displayName, entry: panel.displayName }}/>
                    ))
                }
            </Scroller>
        );
    }
}

NavigationMenu.propTypes = {
    config: PropTypes.object,
    theme: PropTypes.string,
    mode: PropTypes.string,
    locale: PropTypes.string,
    shouldPreRender: PropTypes.bool,
    currency: PropTypes.object,
    rollouts: PropTypes.object
};

NavigationMenu.defaultProps = {
    mode: 'default',
    shouldPreRender: true,
    rollouts: {}
};

export default NavigationMenu;
